export function renderGradeInLaurel(grade) {
  const match = /^([A-F])([+-])$/.exec(grade);
  if (!match) return grade;

  return (
    <>
      <span className="containerGrade__letter">{match[1]}</span>
      <sup className="containerGrade__modifier">{match[2]}</sup>
    </>
  );
}

export function getWordEwssDisplayGrade(word) {
  const retention = word?.stats?.retention;
  if (retention?.insufficientData || retention?.grade == null) return null;
  return String(retention.grade).trim();
}
